module.exports = __webpack_public_path__ + "img/hikari_zero.ef395bba.png";